import React, {FC} from "react";
import {ProTable} from "@/widget/ProTable/ProTable";
import {GridColDef} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import {formatTime} from "@/helper/method";
import {ContractPageVO, useQueryContractPage} from "@/service/contract.s";

export interface ContractTableProps {
    customerId?: number;
    enabled?: boolean;
}

export const ContractTable: FC<ContractTableProps> = ({customerId, enabled = true}) => {
    const {
        mutate: contactPageMutate,
        data: contactPageData,
        isPending: contactPagePending,
    } = useQueryContractPage()

    const columns: GridColDef<ContractPageVO>[] = [
        {
            field: "contractName",
            headerName: "合同名称",
            headerAlign: "left",
            align: "left",
            flex: 0.6,
        },
        {
            field: "kinds",
            headerName: "服务类型",
            headerAlign: "center",
            align: "center",
            flex: 0.4, valueFormatter: value => value || '-'
        },
        {
            field: "contractNum",
            headerName: "合同编号",
            headerAlign: "center",
            align: "center",
            flex: 0.5
        },
        {
            field: "dealTime",
            headerName: "成交日期",
            headerAlign: "right",
            flex: 0.4,
            align: "right",
            valueFormatter: (value) => formatTime("D", value),
        },
        {
            field: "totalPrice",
            headerName: "总价",
            headerAlign: "center",
            align: "center",
            flex: 0.4,
            renderCell: ({row}) => <Box color={'red'} component={'span'}>{`${row.totalPrice}`}</Box>
        }]

    return <ProTable<ContractPageVO> checkboxSelection={false} columnHeaderHeight={40} loading={contactPagePending}
                                     onSearch={(params) => enabled && contactPageMutate({...params, customerId})}
                                     data={contactPageData?.data} pageSize={5} showToolbar={false} autoHeight={false}
                                     columns={columns}/>
}